import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const SendIcon = (props: Props) => (
  <Svg viewBox='0 0 17 16' fill='none' {...props}>
    <Path
      d='M15.1666 1.33337L7.83325 8.66671M15.1666 1.33337L10.4999 14.6667L7.83325 8.66671M15.1666 1.33337L1.83325 6.00004L7.83325 8.66671'
      stroke='white'
      strokeWidth={1.6}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
